import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-multiml-configuracion-modal.component.html",
    styleUrls: ["./tipo-multiml-configuracion-modal.component.scss"]
})
export class TipoMultimlConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
